module.exports = __webpack_public_path__ + "img/step4.76bc9040.svg";